export default {
    path: '/',
    redirect: '/login',
    component: () => import(/*webpackChunkName: 'pc-login'*/ '@views/login/index'),
    meta: {
        title: '登录'
    }
}
